<!-- 公共轮播图组件 -->
<template>
    <div class="hetad_banner" :style="{height:fullScreen?fullHeight:height}">
        <Swipe class="my-swipe" :height="fullScreen?fullHeight:height" :autoplay="3000" :show-indicators="false" v-if="list.length > 0">
            <swipe-item v-for="(item, index) in list" :key="index">
                <van-image :height="fullScreen?fullHeight:height" fit="cover" :src="item" />
            </swipe-item>
        </Swipe>
    </div>
</template>

<script setup>
import { reactive, defineProps, ref } from "vue";
import { Swipe, SwipeItem } from 'vant';
import { Image as VanImage } from 'vant';

const props = defineProps({
    list: {
        type: Array,
        default: [],
    },
    srcName: {
        type: String,
        default: 'img'
    },
    height: {
        type: String,
        default: '27.06rem',
    },
    fullScreen: {
        type: Boolean,
        default: false
    }
})

const fullHeight = ref((window.innerHeight - 52) + 'px')


</script>

<style scoped lang='scss'>
.hetad_banner {
    width: 100vw;

    .my-swipe {
        width: 100%;
    }
}
</style>